import LayoutBackend from '@/layouts/variations/Backend.vue';
import { checkAuth, isMobile } from '@/router/helpers.js';

const Lotto = () => /* webpackChunkName: "group-lotto" */ import('@/views/Lotto/Lotto.vue');
const MobileBuy = () => /* webpackChunkName: "group-lotto" */ import('@/views/Lotto/mobile/Buy.vue');
const MobileResult = () => /* webpackChunkName: "group-lotto" */ import('@/views/Lotto/mobile/Result.vue');
const MobileGuide = () => /* webpackChunkName: "group-lotto" */ import('@/views/Lotto/components/Guide.vue');
const MobileContract = () => /* webpackChunkName: "group-lotto" */ import('@/views/Lotto/components/Contract.vue');
const MobileByNum = () => /* webpackChunkName: "group-lotto" */ import('@/views/Lotto/components/statistics/ByNum.vue');
const MobileByPeriod = () =>
  /* webpackChunkName: "group-lotto" */ import('@/views/Lotto/components/statistics/ByPeriod.vue');

const lotto = [
  {
    path: '/lotto',
    redirect: '/lotto/home',
    component: LayoutBackend,
    beforeEnter: checkAuth(),
    children: [
      {
        path: 'home',
        name: 'Lotto',
        component: Lotto,
      },
      {
        path: 'buy',
        name: 'LottoBuy',
        component: MobileBuy,
        beforeEnter: isMobile('lotto'),
      },
      {
        path: 'result',
        name: 'LottoResult',
        component: MobileResult,
        beforeEnter: isMobile('lotto'),
      },
      {
        path: 'guide',
        name: 'LottoGuide',
        component: MobileGuide,
        beforeEnter: isMobile('lotto'),
      },
      {
        path: 'contract',
        name: 'LottoContract',
        component: MobileContract,
        beforeEnter: isMobile('lotto'),
      },
      {
        path: 'number',
        name: 'ByNum',
        component: MobileByNum,
        beforeEnter: isMobile('lotto'),
      },
      {
        path: 'period',
        name: 'ByPeriod',
        component: MobileByPeriod,
        beforeEnter: isMobile('lotto'),
      },
    ],
  },
];

export { lotto };
